module.exports = __webpack_public_path__ + "img/theme5.e057174c.png";